<script setup>
import RealEstateCommissionSupportDesktopTable from './RealEstateCommissionSupportDesktopTable.vue';
import RealEstateCommissionSupportToolbar from './RealEstateCommissionSupportToolbar.vue';

defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  tab: { type: String, default: 'para_enviar' },
  page: { type: Number, default: 1 },
  totalRows: { type: Number, default: 0 },
  totalPages: { type: Number, default: 0 },
});

const emit = defineEmits([
  'open',
  'details',
  'changePage',
  'toggleFilters',
  'toggleOrder',
]);
</script>

<template>
  <section
    class="w-full min-w-0 overflow-hidden rounded-[12px] border-2 border-[#E0E7EB] bg-white"
  >
    <RealEstateCommissionSupportToolbar
      :page="page"
      :total-pages="totalPages"
      :total-rows="totalRows"
      :shown-rows="rows.length"
      :is-loading="loading"
      @toggle-filters="emit('toggleFilters')"
      @toggle-order="emit('toggleOrder')"
      @change-page="emit('changePage', $event)"
    />
    <div v-if="loading" class="space-y-3 p-5">
      <div
        v-for="index in 5"
        :key="index"
        class="h-12 animate-pulse rounded-lais bg-lais-bg-soft"
      />
    </div>
    <div
      v-else-if="!rows.length"
      class="p-10 text-center text-sm text-lais-text-muted"
    >
      {{ $t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.EMPTY') }}
    </div>
    <template v-else>
      <RealEstateCommissionSupportDesktopTable
        :rows="rows"
        :tab="tab"
        @open="emit('open', $event)"
        @details="emit('details', $event)"
      />
    </template>
  </section>
</template>
